"use strict";
exports.__esModule = true;
exports.SuggestPaymentDateReason = exports.PAYMENT_BALANCE_PARAM = exports.PaymentErrorCode = void 0;
var PaymentErrorCode;
(function (PaymentErrorCode) {
    PaymentErrorCode["RepaymentWindowExpired"] = "P50001";
    PaymentErrorCode["FundsSuccessCardFailure"] = "P50002";
})(PaymentErrorCode = exports.PaymentErrorCode || (exports.PaymentErrorCode = {}));
exports.PAYMENT_BALANCE_PARAM = 'balance';
var SuggestPaymentDateReason;
(function (SuggestPaymentDateReason) {
    SuggestPaymentDateReason["NO_CHANGE"] = "NO_CHANGE";
    SuggestPaymentDateReason["WEEKEND"] = "WEEKEND";
    SuggestPaymentDateReason["END_OF_MONTH_WEEKEND"] = "END_OF_MONTH_WEEKEND";
    SuggestPaymentDateReason["END_OF_MONTH_WEEKDAY"] = "END_OF_MONTH_WEEKDAY";
    SuggestPaymentDateReason["LATE_DATE"] = "LATE_DATE";
})(SuggestPaymentDateReason = exports.SuggestPaymentDateReason || (exports.SuggestPaymentDateReason = {}));
